import React, { useEffect } from "react"
import { useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Card,
  Button,
  CardBody,
  Checkbox,
  CardFooter,
  CheckboxGroup,
} from "@nextui-org/react"
import { useEdit, useFetchWithBody } from "../../api/reactQueryCustomHooks.jsx"
import { LoadingCard, MainContainer } from "../../components/index.js"
import { apiRoute, linksUrl } from "../../constants/enum.js"

function EditUserMenuMapping() {
  const navigate = useNavigate()
  const { selectedUser } = useSelector((state) => state.userMaster)
  const { selectedClient } = useSelector((state) => state.clientMaster)
  const { appClientMapping } = useSelector((state) => state.appClientMapping)
  const {
    data: allAppMenu = [],
    isLoading: isAllAppMenuLoading,
    isFetching: isAllAppMenuFeatching,
  } = useFetchWithBody({
    url: apiRoute.userMenuMapping.read,
    queryKey: "allAppMenu",
    inputData: {
      userId: selectedUser.UserId,
      option: 3,
    },
  })


  const [selectedUserMenu, setSelectedUserMenu] = useState([])
  useEffect(() => {
    setSelectedUserMenu(allAppMenu.filter((item) => item.Id).map((item) => item.MenuId))
  }, [allAppMenu])
  const resetValues = () => { }

  const onSuccessTasks = () => {
    navigate(linksUrl.userMenuMapping.read)
  }

  const { isPending, mutate: editUserMenuMapping } = useEdit({
    url: apiRoute.userMenuMapping.edit,
    queryKey: "UserMenuMapping",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const onClickPrevPage = () => {
    navigate(linksUrl.userMenuMapping.read)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    editUserMenuMapping({
      data: {
        allAppMenu,
        selectedUserMenu,
        userId: selectedUser.UserId,
        client_code: selectedClient.client_code,
      },
    })
  }
  console.log(selectedUserMenu)

  if (isAllAppMenuLoading || isAllAppMenuFeatching) {
    return <LoadingCard />
  }

  return (
    <MainContainer
      breadcrumbs={["User Master", "Menu Master", "Edit"]}
      pageName={"Edit Menu"}
      prevPage={{ show: true, onClick: onClickPrevPage }}
      headingCardProps={{
        show: true,
        items: [
          {
            heading: "Client",
            labels: [selectedClient.client_name, selectedClient.client_code],
          },
          {
            heading: "User",
            labels: [selectedUser.LoginName],
          },
          {
            heading: "App",
            labels: appClientMapping && appClientMapping.map((item) => item.AppName),
          },
        ],
      }}
    >
      <div className="mt-0 flex ">
        <div className="py-2 w-96">
          <Card className="max-w-[600px]" shadow="none" classNames="p-0">
            <form onSubmit={handleSubmit}>
              <CardBody className="p-0">
                <div className="flex flex-col gap-4 mx-2">
                  <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                    <CheckboxGroup
                      label=""
                      value={selectedUserMenu}
                      onValueChange={setSelectedUserMenu}
                    >
                      {allAppMenu.map((item) => {
                        return (
                          <Checkbox key={item.MenuId} value={item.MenuId}>
                            {item.MenuName}
                          </Checkbox>
                        )
                      })}
                    </CheckboxGroup>
                  </div>
                </div>
              </CardBody>
              <CardFooter>
                <Button color="primary" type="submit" isLoading={isPending}>
                  Edit Menu
                </Button>
              </CardFooter>
            </form>
          </Card>
        </div>
      </div>
    </MainContainer>
  )
}
export default EditUserMenuMapping
